import {checkParentDetermination, updateContextElements} from '../Form/CheckboxGroup';
import {translate} from '../../Library/Translator';

export const isLockedPermission = checkbox => checkbox.getAttribute('aria-disabled') === 'true';

const tickedDependents = (permissions, checkbox) => checkbox.dataset.requiredBy
    .split(' ')
    .filter(dependent => permissions.querySelector(`[data-checkbox-group="${dependent}"]`).checked)
;

const retick = checkbox => {
    checkbox.checked = true;
    checkParentDetermination(checkbox.dataset.checkboxGroup);
    updateContextElements(checkbox.dataset.checkboxGroup);
};

const reflectLock = (checkbox, neededBy) => {
    const note = checkbox.closest('.item').querySelector('.needed-by');

    note.hidden = neededBy.length === 0;

    if (note.hidden) {
        checkbox.removeAttribute('aria-disabled');
        checkbox.removeAttribute('aria-describedby');

        return;
    }

    const holderTitles = JSON.parse(note.dataset.holderTitles);

    note.querySelector('span').textContent = translate(
        'page.store.settings.user.permissions.neededBy',
        neededBy.map(holder => holderTitles[holder]).join(', '),
    );
    checkbox.setAttribute('aria-disabled', 'true');
    checkbox.setAttribute('aria-describedby', note.id);
};

export const syncPermissionDependencies = permissions => {
    permissions.querySelectorAll('[data-required-by]').forEach(checkbox => {
        const neededBy = tickedDependents(permissions, checkbox);

        if (neededBy.length > 0 && !checkbox.checked) {
            retick(checkbox);
        }

        reflectLock(checkbox, neededBy);
    });
};

document.addEventListener('groupedcheckboxchanged', event => {
    const permissions = event.checkbox.closest('.permissions');

    if (!permissions) {
        return;
    }

    syncPermissionDependencies(permissions);
});
